import { z } from 'zod';

/**
 * Trimmed Kartverket "Se havnivå" tideapi.php response (spec 12) — the API
 * parses upstream XML and never forwards it to the client. `refcode` is
 * always `'cd'` (cm above sjøkartnull / chart datum) — the load-bearing
 * choice that lets the UI compose charted depth + water level.
 */
export const tideSeriesPoint = z.object({
  ts: z.number(),
  cm: z.number(),
  kind: z.enum(['pred', 'obs', 'forecast']),
});
export type TideSeriesPoint = z.infer<typeof tideSeriesPoint>;

export const tideExtreme = z.object({
  ts: z.number(),
  cm: z.number(),
});
export type TideExtreme = z.infer<typeof tideExtreme>;

export const tideResponse = z.object({
  refcode: z.literal('cd'),
  stationName: z.string().nullable(),
  series: z.array(tideSeriesPoint),
  nextHigh: tideExtreme.nullable(),
  nextLow: tideExtreme.nullable(),
});
export type TideResponse = z.infer<typeof tideResponse>;
